"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipTheme = void 0;

var tooltipTheme = function tooltipTheme(theme) {
  return {
    tooltip: {
      backgroundColor: theme.palette.text.primary,
      fontSize: 14,
      padding: '2.5px 8px',
      maxWidth: 200
    },
    arrow: {
      color: theme.palette.text.primary
    }
  };
};

exports.tooltipTheme = tooltipTheme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1Rvb2x0aXAvdG9vbHRpcFRoZW1lLnRzeCJdLCJuYW1lcyI6WyJ0b29sdGlwVGhlbWUiLCJ0aGVtZSIsInRvb2x0aXAiLCJiYWNrZ3JvdW5kQ29sb3IiLCJwYWxldHRlIiwidGV4dCIsInByaW1hcnkiLCJmb250U2l6ZSIsInBhZGRpbmciLCJtYXhXaWR0aCIsImFycm93IiwiY29sb3IiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFJTyxJQUFNQSxZQUFZLEdBQUcsU0FBZkEsWUFBZSxDQUFDQyxLQUFEO0FBQUEsU0FBb0U7QUFDOUZDLElBQUFBLE9BQU8sRUFBRTtBQUNQQyxNQUFBQSxlQUFlLEVBQUVGLEtBQUssQ0FBQ0csT0FBTixDQUFjQyxJQUFkLENBQW1CQyxPQUQ3QjtBQUVQQyxNQUFBQSxRQUFRLEVBQUUsRUFGSDtBQUdQQyxNQUFBQSxPQUFPLEVBQUUsV0FIRjtBQUlQQyxNQUFBQSxRQUFRLEVBQUU7QUFKSCxLQURxRjtBQU85RkMsSUFBQUEsS0FBSyxFQUFFO0FBQ0xDLE1BQUFBLEtBQUssRUFBRVYsS0FBSyxDQUFDRyxPQUFOLENBQWNDLElBQWQsQ0FBbUJDO0FBRHJCO0FBUHVGLEdBQXBFO0FBQUEsQ0FBckIiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBUb29sdGlwQ2xhc3NLZXkgfSBmcm9tICdAbWF0ZXJpYWwtdWkvY29yZSc7XG5pbXBvcnQgeyBDU1NQcm9wZXJ0aWVzIH0gZnJvbSAnQG1hdGVyaWFsLXVpL2NvcmUvc3R5bGVzL3dpdGhTdHlsZXMnO1xuaW1wb3J0IHsgVGhlbWUgfSBmcm9tICcuLi9UaGVtZS90aGVtZSc7XG5cbmV4cG9ydCBjb25zdCB0b29sdGlwVGhlbWUgPSAodGhlbWU6IFRoZW1lKTogUGFydGlhbDxSZWNvcmQ8VG9vbHRpcENsYXNzS2V5LCBDU1NQcm9wZXJ0aWVzPj4gPT4gKHtcbiAgdG9vbHRpcDoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUucGFsZXR0ZS50ZXh0LnByaW1hcnksXG4gICAgZm9udFNpemU6IDE0LFxuICAgIHBhZGRpbmc6ICcyLjVweCA4cHgnLFxuICAgIG1heFdpZHRoOiAyMDAsXG4gIH0sXG4gIGFycm93OiB7XG4gICAgY29sb3I6IHRoZW1lLnBhbGV0dGUudGV4dC5wcmltYXJ5LFxuICB9LFxufSk7XG4iXX0=